export class TextEmbeddingApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns number
     * @throws ApiError
     */
    generateEmbedding({ requestBody, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/text-embedding',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
